var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiurno(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#f9ca24;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.045,12.773A2.273,2.273,0,1,1,12.773,10.5,2.273,2.273,0,0,1,15.045,12.773Z",
    transform: "translate(-7.773 -7.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,1.5v.909",
    transform: "translate(-13 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,31.5v.909",
    transform: "translate(-13 -22.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.33,6.33l.645.645",
    transform: "translate(-4.866 -4.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.54,27.54l.645.645",
    transform: "translate(-19.649 -19.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.5,18h.909",
    transform: "translate(-1.5 -13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.5,18h.909",
    transform: "translate(-22.409 -13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.33,28.185l.645-.645",
    transform: "translate(-4.866 -19.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.54,6.975l.645-.645",
    transform: "translate(-19.649 -4.866)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiurno);
export default __webpack_public_path__ + "static/media/icon-diurno.7eda45b263ec67a6f0581162566caad2.svg";
export { ForwardRef as ReactComponent };